// Referee Trend — types + selection (Phase 3, D3 SVG bar chart).
//
// One referee's recent matches, each a stacked bar of yellow + red cards. The
// bar geometry lives in the component (a full clear+redraw, no animation); the
// pure part is just picking the ref's matches.

/** One match a referee officiated: date, teams, card counts. */
export interface RefTrendMatch {
  date: string;
  home: string;
  away: string;
  yc: number;
  rc: number;
}

/** Referee Trend data keyed by referee name. */
export type RefTrendData = Record<string, RefTrendMatch[]>;

/** The match list for a referee (`[]` when missing). */
export function selectRefTrend(
  data: RefTrendData,
  ref: string
): RefTrendMatch[] {
  return data[ref] ?? [];
}
